import NotSupported from './components/NotSupported';
import styles from './MobileUnsupported.module.css';

const MobileUnsupported = () => {
  return (
    <div className={styles.container}>
      <NotSupported />
      <h3 className={styles.title}>Mobile Access Not Supported</h3>
      <span className={styles.description}>
        This portal is currently only available on desktop or laptop devices.
      </span>
    </div>
  );
};

export default MobileUnsupported;
